export default{

    soloGame : [],
    gameSetId : '',
    now : ''
}